import "iframe-resizer/js/iframeResizer.contentWindow";

import "bootstrap";
import './application.scss';

import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/pro-solid-svg-icons';
import {far} from '@fortawesome/pro-regular-svg-icons';

library.add(fas, far);
dom.watch();
